import styled from "styled-components"

const RowNumbersStyled = styled.section`
  .numbers {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding-bottom: 60px;
    @media (max-width: 880px) {
      padding-bottom: 30px;
    }
    &--6 {
      .numbers__item {
        width: calc(33% - 60px);
        max-width: 340px;
        margin-right: 90px;
        &:nth-of-type(3n) {
          margin-right: 0;
        }
      }
    }
    &--5 {
      .numbers__item {
        width: calc(33% - 60px);
        max-width: 340px;
        margin-right: 90px;
        &:nth-of-type(3n) {
          margin-right: 0;
        }
        &:nth-last-of-type(1) {
          padding-bottom: 0;
        }
        &:nth-last-of-type(2) {
          padding-bottom: 0;
        }
        @media (max-width: 1080px) {
          width: calc(33% - 20px);
          max-width: 340px;
          margin-right: 30px;
        }
        @media (max-width: 880px) {
          width: calc(50% - 20px);
          max-width: 340px;
          margin-right: 30px;
          &:nth-of-type(3n) {
            margin-right: 20px;
          }
          &:nth-of-type(2n) {
            margin-right: 0px;
          }
        }
        @media (max-width: 600px) {
          width: 100%;
          max-width: 340px;
          margin-right: 0;
          &:nth-of-type(3n) {
            margin-right: 0px;
          }
          &:nth-of-type(2n) {
            margin-right: 0px;
          }
        }
      }
    }
    &--3 {
      .numbers__item {
        width: calc(33% - 40px);
        max-width: 340px;
        margin-right: 45px;
        @media (max-width: 880px) {
          flex-wrap: wrap;
        }
        @media (max-width: 880px) {
          width: calc(50% - 20px);
          margin-right: 40px;
          &:nth-of-type(2n) {
            margin-right: 0;
          }
        }
        @media (max-width: 440px) {
          width: 100%;
          margin-right: 0;
        }
        &:nth-of-type(3n) {
          margin-right: 0;
        }
      }
    }
    &--4 {
      @media (max-width: 880px) {
        flex-wrap: wrap;
      }
      .numbers__item {
        width: calc(25% - 40px);
        margin-right: 40px;
        @media (max-width: 880px) {
          width: calc(50% - 20px);
          &:nth-of-type(2n) {
            margin-right: 0;
          }
        }
        @media (max-width: 440px) {
          width: 100%;
          margin-right: 0;
        }
      }
    }
    &--2 {
      justify-content: space-around;
      .numbers__item {
        width: calc(50% - 40px);
        max-width: 290px;
      }
    }
    &__item {
      padding-bottom: 90px;
      @media (max-width: 1080px) {
        padding-bottom: 70px !important;
      }
      @media (max-width: 1080px) {
        padding-bottom: 30px !important;
      }
    }
    &__number {
      font-size: 74px;
      font-weight: 600;
      text-align: center;
      margin: 0;
      @media (max-width: 880px) {
        font-size: 50px;
      }
    }
    &__description {
      padding-top: 30px;
      font-size: 18px;
      text-align: center;
      margin: 0;
    }
  }
`

export default RowNumbersStyled
